var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSoundFill16 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m10.682 11.503 1.355 1.354a.75.75 0 0 0 1.06-1.06L4.713 3.411a.75.75 0 0 0-1.06 1.06l1 1a1.55 1.55 0 0 0-.997 1.448v2.184c0 .855.693 1.548 1.548 1.548h1.758l2.926 2.131a.5.5 0 0 0 .794-.404zM9.176 5.777 10.682 7.3V3.645a.5.5 0 0 0-.794-.405L8.016 4.604z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSoundFill16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };